import { Card, CardBody, Col } from "reactstrap";
import { UL } from "../../../../AbstractElements";
import HoverAnnualFunction from "./HoverAnnualFunction";
import HoverFresherInterview from "./HoverFresherInterview";
import HoverMeetup from "./HoverMeetup";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { HoverTimelineTitle } from "../../../../Constants/Constants";
import { HoverTimelineSubTitle } from "../../../../Data/BonusUi/Timeline";

const HoverTimeline = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={HoverTimelineTitle} span={HoverTimelineSubTitle} />
        <CardBody>
          <UL className="square-timeline simple-list">
            <HoverAnnualFunction />
            <HoverFresherInterview />
            <HoverMeetup />
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};
export default HoverTimeline;
